<app-menu-common url="sales"></app-menu-common>

<div class="renewal-page">
  <div class="toolbar-card">
    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">medical_information</mat-icon>
      <span>Renouvellement d'ordonnance</span>
    </div>

    <!-- Dernier jour qui doit être couvert : par défaut aujourd'hui + le délai de c_values 34 (prescription_renewal_days). -->
    <div class="filter-item date-filter" matTooltip="Matériels dont l'ordonnance manque ou expire avant ce jour">
      <app-select-date label="Couverts jusqu'au" [date]="until" (dateChange)="untilChange($event)"></app-select-date>
    </div>

    <div class="toolbar-actions">
      <button mat-stroked-button class="btn-inline btn-ghost" aria-label="Actualiser" matTooltip="Relancer le calcul" (click)="reload()">
        <mat-icon [class.spinning]="loading">refresh</mat-icon>
      </button>
    </div>
  </div>

  <div class="table-card">
    <div class="table-header-bar">
      <div class="header-left">
        <div class="table-title">
          <mat-icon>person</mat-icon>
          <span>Patients</span>
          <span class="badge-count">{{ patients.length }}</span>
          <span class="muted">{{ lineCount() }} matériel{{ lineCount() > 1 ? 's' : '' }}</span>
        </div>
        <div class="batch-actions">
          <button mat-button color="primary" class="btn-batch" (click)="selectAll()" [disabled]="patients.length === 0">
            <mat-icon>select_all</mat-icon>
            Tout sélectionner
          </button>
          <button mat-button class="btn-batch" (click)="deselectAll()" [disabled]="selected.size === 0">
            <mat-icon>deselect</mat-icon>
            Désélectionner
          </button>
          @if (selected.size > 0) {
            <span class="selection-badge">{{ selected.size }} sélectionné{{ selected.size > 1 ? 's' : '' }}</span>
          }
        </div>
      </div>
      <div class="header-right">
        <button mat-flat-button color="primary" (click)="print()" [disabled]="selected.size === 0 || printing" matTooltip="Une lettre par patient sélectionné, toutes dans un seul PDF">
          <mat-icon>print</mat-icon>
          <span>Imprimer les demandes</span>
        </button>
      </div>
    </div>

    <div class="renewal-grid">
      <div class="renewal-line entete">
        <div class="cell select-cell">
          <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isPartiallySelected()" (change)="toggleSelectAll()" color="primary" matTooltip="Tout sélectionner / désélectionner"></mat-checkbox>
        </div>
        <div class="cell">Patient</div>
        <div class="cell">Commune</div>
        <div class="cell">Matériel</div>
        <div class="cell">Dossier</div>
        <div class="cell">Ordonnance</div>
      </div>

      @if (patients.length > 0) {
        @for (p of patients; track p.id; let isEven = $even) {
          <div class="renewal-line" [class.even]="isEven" [class.selected]="isSelected(p.id)" (click)="toggle(p.id)">
            <div class="cell select-cell" (click)="$event.stopPropagation()">
              <mat-checkbox [checked]="isSelected(p.id)" (change)="toggle(p.id)" color="primary"></mat-checkbox>
            </div>
            <div class="cell patient-cell">
              <a [routerLink]="['/common/partner', p.id]" target="_blank" (click)="$event.stopPropagation()" matTooltip="Fiche du patient">{{ name(p) || ('Tiers ' + p.id) }}</a>
            </div>
            <div class="cell">{{ p.zip }} {{ p.city }}</div>
            <div class="cell stack">
              @for (l of p.lines; track l.line_id) {
                <div class="item" [matTooltip]="article(l)">{{ title(l) }}@if (l.interrupted) {<span class="chip" matTooltip="Une interruption sans date de retour couvre aujourd'hui (hospitalisation…)">Interrompu</span>}</div>
              }
            </div>
            <div class="cell stack">
              @for (l of p.lines; track l.line_id) {
                <div class="item"><a [routerLink]="['/rental', l.order_id]" target="_blank" (click)="$event.stopPropagation()">{{ l.order_id }}</a></div>
              }
            </div>
            <div class="cell stack">
              @for (l of p.lines; track l.line_id) {
                <div class="item" [class.expired]="isExpired(l)">{{ coverage(l) }}</div>
              }
            </div>
          </div>
        }
      } @else if (loading) {
        <div class="state">
          <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
          <span>Calcul des ordonnances de tous les dossiers…</span>
        </div>
      } @else {
        <div class="state">
          <mat-icon class="empty-icon">task_alt</mat-icon>
          <div class="empty-title">Aucune ordonnance à renouveler</div>
          <div class="empty-subtitle">Tous les matériels loués qui exigent une ordonnance sont couverts jusqu'au jour choisi.</div>
        </div>
      }
    </div>
  </div>
</div>
